import * as React from 'react';
import { Alert, Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import Swal from 'sweetalert2';
import { TabulatorFull as Tabulator } from "tabulator-tables";
import { useAppDispatch, useAppSelector } from '../hooks/index';
import { B2CUser, deactivateUser, getB2CUserInfo, NewSignupUser, registerUser, selectUserCheck } from '../redux/RegistrationSlice';
import { equalizeName, UserRoleEnum } from '../redux/UserSlice';
import { getAllUsersAsync, getIsAdminUserManager, selectUsers, updateAttribute } from "../redux/UsersSlice";
import dateHelper from '../utils/dateHelper';
import Page from './Page';
import classnames from 'classnames';
import { unwrapResult } from '@reduxjs/toolkit';



const AdminManager = () => {
    const dispatch = useAppDispatch();
    const userList = useAppSelector(selectUsers);
    var registerValue: B2CUser | null = useAppSelector(selectUserCheck);
    var tabulatorRef = React.useRef<any>(null);
    const [isAdminUserManager, setIsAdminUsermanager] = React.useState<boolean>(false);

    const handleCellEdited = function (cell: any) {
        var row = cell.getRow();
        var userid = row.getData().id;
        var fieldid = cell.getField();
        var newvalue = cell.getValue();

        if (fieldid === "deprecateDate") {

            var activateDate = row.getData().activateDate;
            var deprecateDate = row.getData().deprecateDate;

            if (dateHelper.isLeftDateStringBeforeRightDateString(activateDate, deprecateDate) == false) {
                let deprecateDateMessage:
                    string = `The deprecation date (${dateHelper.stringDateInFormat(deprecateDate, "LL/dd/yyyy")}) `
                    + `cannot be before the activation date (${dateHelper.stringDateInFormat(activateDate, "LL/dd/yyyy")}).`
                setModalMessage(deprecateDateMessage);
                toggle();

            }
        }
        dispatch(updateAttribute({ id: userid, fieldId: fieldid, value: newvalue }));
    }


    const handleDeprecateUser = async (): Promise<void> => {
        await dispatch(deactivateUser(userDeprecation));
        await dispatch(getAllUsersAsync());
        Swal.fire({
            icon: 'success',
            title: 'Deactivation complete',
            showConfirmButton: false,
            timer: 1500
        })
    }


    const defaultColumns = [
        { title: 'First Name', field: 'firstName', editor: "input", editable: isAdminUserManager },
        { title: 'Last Name', field: 'lastName', editable: isAdminUserManager },
        { title: 'Admin Name', field: 'login', editable: isAdminUserManager },
        {
            title: 'Creation', field: 'createDate',
            formatter: "datetime", formatterParams: {
                outputFormat: "MM/DD/YYYY",
            }, editable: isAdminUserManager
        },
        {
            title: 'Last Login', field: 'lastLoginDate',
            formatter: "datetime", formatterParams: {
                outputFormat: "MM/DD/YYYY",
                inputFormat: "",
            }, editable: isAdminUserManager
        },
        { title: 'Status', field: 'status', editable: isAdminUserManager },
        {
            title: 'Deprecation', field: 'deprecateDate',
            editor: "date",
            editorParams: {
                format: "iso", // the format of the date value stored in the cell
                elementAttributes: {
                    title: "slide bar to choose option" // custom tooltip
                },
            },
            formatter: dateHelper.tabulatorDateFormatter(),
            cellEdited: handleCellEdited,
            editable: isAdminUserManager
        },
        {
            title: 'Activation', field: 'activateDate',
            formatter: dateHelper.tabulatorDateFormatter(),
            editable: isAdminUserManager
        },
    ];

    const options = {
        cellEdited: (cell: any) => handleCellEdited(cell),
    };

    const [adminName, setAdminName] = React.useState<string>("");
    const [userDeprecation, setUserDeprecation] = React.useState<string>("");

    const [userLogin, setUserLogin] = React.useState<string>("");
    const [firstName, setFirstName] = React.useState<string>("");
    const [lastName, setLastName] = React.useState<string>("");

    const handleOnAdd = async () => {
        let newUser: NewSignupUser = {
            firstName: "",//will pull from b2c
            lastName: "",//will pull from b2c
            eMail: adminName,
            role: UserRoleEnum.Admin
        };

        await dispatch(registerUser(newUser))
            .then((result: any) => {
                setAdminName("");
                dispatch(getAllUsersAsync());
            });
    };

    const handleOnEqualizeNameClick = async () => {

        var loginAndName: { Item1: string; Item2: string; Item3: string } =
        {
            Item1: userLogin,
            Item2: firstName,
            Item3: lastName
        }
        dispatch(equalizeName(loginAndName));
        clearEqualizeInputs();

        Swal.fire({
            icon: 'success',
            title: 'Synchronization complete',
            showConfirmButton: false,
            timer: 1500
        })
    };

    const [modal, setModal] = React.useState(false);
    const toggle = () => { setModal(!modal); }
    const [modalMessage, setModalMessage] = React.useState("");

    const [equalizeNameModal, setEqualizeNameModal] = React.useState(false);
    const equalizeNameToggle = () => { setEqualizeNameModal(!equalizeNameModal) }

    const [activeTab, setActiveTab] = React.useState('1');
    const toggleTab = (tab: any) => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const [userName, setUserName] = React.useState<string>('johnson.amosm@gmail.com');

    const onLookupButtonClick = async () => {
        await dispatch(getB2CUserInfo(userName));
    }

    const onEqualizeClick = () => {
        equalizeNameToggle();
    }

    const clearEqualizeInputs = () => {
        equalizeNameToggle();
        setFirstName("");
        setLastName("");
        setUserLogin("");
    };;

    React.useEffect(() => {
        if (userList.length === 0) {
            dispatch(getAllUsersAsync());
           
        }
    }, [])

    const verifyIsAdminUserManager = async () => {
        const response = await dispatch(getIsAdminUserManager());
        const isAdminUserManagerResult: boolean = unwrapResult(response);
        setIsAdminUsermanager(isAdminUserManagerResult);

    }

    React.useEffect(() => {
        verifyIsAdminUserManager()
    }, [])

    React.useEffect(() => {
        tabulatorRef.current = new Tabulator('#adminList', {
            data: userList,
            columns: defaultColumns,
            layout: "fitColumns",
        });
    }, [, userList, setIsAdminUsermanager])

    return (

        <Page>
            <Nav tabs>
                <NavItem>
                    <NavLink
                        className={classnames({ active: activeTab === '1' })}
                        onClick={() => { toggleTab('1'); }}>
                        Admin List
                    </NavLink>
                </NavItem>
                <NavItem hidden={isAdminUserManager == false}>
                    <NavLink
                        className={classnames({ active: activeTab === '2' })}
                        onClick={() => { toggleTab('2'); }}>
                        Maintenance
                    </NavLink>
                </NavItem>
                <NavItem >
                    <NavLink
                        className={classnames({ active: activeTab === '3' })}
                        onClick={() => { toggleTab('3'); }}>
                        Service
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                    <Row style={{ marginBottom: "2em", marginTop:"3em" }}>
                        <Col>
                            <div id="adminList" ref={ele => { tabulatorRef.current = ele }} />
                        </Col>
                    </Row>
                </TabPane>
                <TabPane tabId="2" hidden={isAdminUserManager == false }>
                    <Row style={{ marginBottom: "2em", marginTop: "3em" }}>
                        <Col md="2">
                            <Button type="button"
                                onClick={handleOnAdd}
                                className="taxedit"
                                disabled={adminName.length <= 0}
                            >Add Admin</Button>
                        </Col>
                        <Col>
                            <Input type="email"
                                value={adminName}
                                onChange={(e) => setAdminName(e.currentTarget.value)}
                                style={{ width: "20em" }}
                                placeholder={"ex. First.Last@myfloridacfo.com"}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: "2em" }}>
                        {/*<Registrator />*/}
                        <Col md="2">
                            <Button type="button"
                                onClick={handleDeprecateUser}
                                className="taxedit"
                                disabled={userDeprecation.length <= 0}
                            >Deactivate User</Button>
                        </Col>
                        <Col>
                            <Input
                                type="email"
                                value={userDeprecation}
                                onChange={(e) => setUserDeprecation(e.currentTarget.value)}
                                style={{ width: "20em" }}
                                placeholder={"ex. loginName@mailer.com"}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: "2em" }}>
                        <Col md="2">
                            <Button onClick={onEqualizeClick}
                                disabled={userLogin.length <= 0}
                                className="taxedit"
                            >Sync Name</Button>
                        </Col>
                        <Col>
                            <Input type="text" value={userLogin} style={{ width: "25em" }}
                                onChange={(e) => setUserLogin(e.currentTarget.value)}
                                placeholder={ "ex. loginName@mailer.com" }
                            />
                        </Col>
                    </Row>
                </TabPane>
                <TabPane tabId="3">
                    <Row style={{ marginBottom: "2em", marginTop: "3em" }}>
                        <Col md="2">
                            <Button onClick={onLookupButtonClick}
                                className="taxedit"
                                disabled={userName.length <= 0}
                            >Lookup User</Button>
                        </Col>
                        <Col>
                            <Input type="text" value={userName} style={{ width: "25em" }}
                                onChange={(e) => setUserName(e.currentTarget.value)}
                            />
                        </Col>
                    </Row>

                    <Row style={{ marginBottom: "2em" }}>
                        <Col>
                            {registerValue ?
                                (
                                    <React.Fragment>
                                        <span>Display Name: {registerValue.displayName}</span> <br />
                                        <span>Email: {registerValue.email}</span> <br />
                                        <span>ID: {registerValue.id}</span> <br />
                                        <span>Sign In Email: {registerValue.signInEmail}</span> <br />
                                    </React.Fragment>
                                )
                                :
                                (<p>no result</p>)
                            }
                        </Col>
                    </Row>
                </TabPane>
            </TabContent>

            <Modal isOpen={equalizeNameModal} >
                <ModalHeader >Sync First and Last Names for {userLogin}</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Row>
                                    <Col >
                                        <Label>First Name:</Label>
                                    </Col>
                                    <Col md="9">
                                        <Input type="text"
                                            value={firstName}
                                            onChange={(e) => setFirstName(e.currentTarget.value)}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label>Last Name:</Label>
                                    </Col>
                                    <Col md="9">
                                        <Input type="text"
                                            value={lastName}
                                            onChange={(e) => setLastName(e.currentTarget.value)}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button
                        id="equalizeName"
                        onClick={handleOnEqualizeNameClick}
                        className="taxedit"
                        disabled={firstName.length <= 0 || lastName.length <= 0}
                    >Sync</Button>
                    <Button color="danger"
                        onClick={() => { clearEqualizeInputs(); }}>Cancel</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={modal} toggle={toggle} >
                <ModalHeader toggle={toggle}>Deprecation Date</ModalHeader>
                <ModalBody>
                    <Alert color="danger">
                        {modalMessage}
                    </Alert>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle}>Close</Button>
                </ModalFooter>
            </Modal>

        </Page>
    );
}

export default AdminManager;